import { useEffect } from 'react';
import gs from '../styles/style';
var useLoginTheme = function () {
    useEffect(function () {
        document.body.classList.add(gs('login'));
        return function () { return document.body.classList.remove(gs('login')); };
    }, []);
};
export default useLoginTheme;
